import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { getLightBgColor } from './InduvidualCard';

const MetricTile = ({ item }) => {
  const lightBg = getLightBgColor(item.color, 0.06);

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        backgroundColor: lightBg,
      }}
    >
      <Typography variant="body2">{item.label}</Typography>

      <Typography variant="h6" fontWeight={600} mb={1}>
        {item.value}
      </Typography>

      <SparkLine data={item.trend} color={item.color} />
    </Box>
  );
};

const SparkLine = ({ data = [], color }) => {
  const width = 100;
  const height = 40;

  const max = Math.max(...data);
  const min = Math.min(...data);

  const points = data
    .map((val, i) => {
      const x = (i / (data.length - 1)) * width;
      const y = height - ((val - min) / (max - min || 1)) * height;
      return `${x},${y}`;
    })
    .join(' ');
  return (
    <svg width={width} height={height}>
      <polyline fill="none" stroke={color} strokeWidth="2" points={points} />
    </svg>
  );
};

const KeyMatrixLanding = ({ keyMetricsData = {} }) => {
  const { title = '', metrics = [] } = keyMetricsData;
  return (
    <Box>
      <Typography variant="h6" fontWeight={600} mb={2}>
        {title}
      </Typography>

      <Grid container spacing={2}>
        {metrics?.map((item) => (
          <Grid item xs={12} sm={6} key={item.key}>
            <MetricTile item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default KeyMatrixLanding;
